import { CreateRequestModal } from 'src/components/elements/modals'
import { useGetUserQuery, useVerifyRequestEmailQuery } from 'src/redux/api'
import { useEffect, useState } from 'react'
import { MyModal } from 'src/components/ui'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { skipToken } from '@reduxjs/toolkit/query'
import { useTranslation } from 'react-i18next'
import { CloseIcon } from '@svgs'

export const CreateRequestWithoutAuth = () => {
  const [searchParams] = useSearchParams()
  const email = searchParams.get('email')
  const token = searchParams.get('token')

  const navigate = useNavigate()
  const { isSuccess, isLoading: approveRequestEmailLoading } = useVerifyRequestEmailQuery(
    !email || !token ? skipToken : { email, token },
    {
      skip: !email || !token,
    },
  )
  const { data: user, isLoading: getUserLoading } = useGetUserQuery(undefined)
  const [open] = useState(true)
  const { t } = useTranslation()

  useEffect(() => {
    if (!getUserLoading && (!email || !token) && !user) {
      navigate('/login')
      return
    }
  }, [email, token, getUserLoading, user])

  if (approveRequestEmailLoading || getUserLoading) {
    return (
      <MyModal
        showClose={false}
        width="w-[calc(100%_-_2rem)] md:w-[25rem]"
        open={true}
        handleClose={() => {}}
      >
        <div>{t('common_loading')}</div>
      </MyModal>
    )
  }

  if (isSuccess || user) {
    return <CreateRequestModal open={open} handleClose={() => navigate('/login')} />
  }

  return (
    <div>
      <MyModal
        showClose={false}
        open={true}
        width="w-[calc(100%_-_2rem)] md:w-[25rem]"
        handleClose={() => navigate('/login')}
      >
        <button
          onClick={() => navigate('/login')}
          className="icon-button fill-danger absolute z-20 top-4 right-4 w-4 h-4 hover:fill-danger-strong"
        >
          <CloseIcon />
        </button>
        <div className="text-center font-bold">{t('login.createRequestWithoutAuth.error')}</div>
        <div>{t('login.createRequestWithoutAuth.error_description')}</div>
      </MyModal>
    </div>
  )
}
